let debug = (...args: any[]) => {}

const datePrefix = () => new Date().toTimeString()

const Logger = {

  enabled: value => {

    debug = value ? console.log.bind(window.console, datePrefix()) : () => {}

  }

}

export { debug }
export default Logger
